import Vue from 'vue'
import VueRouter from 'vue-router'
import ViewsCheckIn from '@/views/check-in/ViewsCheckIn'
import { LOCAL_STORAGE_CHANNEL_ID_KEY, LOCAL_STORAGE_CHANNEL_LAST_ACTIVE, LOCAL_STORAGE_CHANNEL_PRACTICE_UUID } from '@/constants'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ViewsCheckIn',
    component: ViewsCheckIn
  },
  {
    path: '/visit',
    name: 'ViewsVisit',
    component: () => import(/* webpackChunkName: "visit" */ '@/views/visit/ViewsVisit')
  },
  {
    path: '/thank-you',
    name: 'ViewsThankYou',
    component: () => import(/* webpackChunkName: "thank-you" */ '@/views/thank-you/ViewsThankYou')
  },
  {
    path: '/verify',
    name: 'ViewsVerify',
    component: () => import(/* webpackChunkName: "verify" */ '@/views/verify/ViewsVerify')
  },
  {
    path: '/generate-test-session',
    name: 'GenerateTestSession',
    component: () => import(/* webpackChunkName: "generate-test-session" */ '@/components/generate-test-session/GenerateTestSession')
  },
  {
    path: '/*',
    redirect: { name: 'ViewsCheckIn' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.practiceUuid) {
    localStorage.setItem(LOCAL_STORAGE_CHANNEL_PRACTICE_UUID, to.query.practiceUuid)
  }

  const practiceUuid = localStorage.getItem(LOCAL_STORAGE_CHANNEL_PRACTICE_UUID)

  if (!practiceUuid) {
    to.params.noPracticeUuid = true
    next()
  } else {
    if (Object.keys(store.getters['entitlements/entitlements']).length === 0) {
      store.dispatch('entitlements/getEntitlements', practiceUuid)
    }

    if (Object.keys(store.getters['practice/practiceInfo']).length === 0) {
      store.dispatch('practice/getPracticeInfo', practiceUuid)
    }
  }

  if (!localStorage.getItem(LOCAL_STORAGE_CHANNEL_ID_KEY) && to.name !== 'ViewsCheckIn' && to.name !== 'ViewsThankYou' && to.name !== 'GenerateTestSession') {
    next({
      name: 'ViewsCheckIn',
      query: to.query
    })
  } else if (localStorage.getItem(LOCAL_STORAGE_CHANNEL_ID_KEY) && to.name !== 'ViewsVerify' && to.name !== 'ViewsVisit' && to.name !== 'GenerateTestSession') {
    // check last active time
    const lastActive = parseInt(localStorage.getItem(LOCAL_STORAGE_CHANNEL_LAST_ACTIVE))
    const timeDiff = Date.now() - new Date(lastActive)

    // if within 2 seconds, then redirect to verify
    if (timeDiff / 1000 < 2) {
      next({
        name: 'ViewsVerify',
        query: to.query
      })
    } else {
      localStorage.removeItem(LOCAL_STORAGE_CHANNEL_ID_KEY)
      localStorage.removeItem(LOCAL_STORAGE_CHANNEL_LAST_ACTIVE)
      next({
        name: 'ViewsCheckIn',
        query: to.query
      })
    }
  } else if (!from.name && to.name === 'ViewsVisit') {
    next({
      name: 'ViewsCheckIn',
      query: to.query
    })
  } else {
    next()
  }
})

export default router
